import { useMutation, UseQueryResult } from '@tanstack/react-query';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2';

import {
	updateInvestorDeclarationsStatus,
	UpdateInvestorDeclarationsStatusProps,
} from '@dealstack/frontend/shared/dataExchange/services/mip.service';

export const useUpdateKycDeclarationsStatus = (getKYCDataRequest: UseQueryResult) => {
	const mutation = useMutation<void, Error, UpdateInvestorDeclarationsStatusProps>({
		mutationFn: updateInvestorDeclarationsStatus,
	});

	const updateKycDeclarationStatus = async (data: UpdateInvestorDeclarationsStatusProps) => {
		mutation.mutate(data, {
			onSuccess: () => {
				void getKYCDataRequest.refetch();

				showToastV2({
					title: 'Updated',
					state: 'success',
				});
			},
		});
	};

	return {
		updateKycDeclarationStatus,
		mutation,
	};
};
